import React, { Component } from 'react'

import TextWithFieldname from '../texts/TextWithFieldname';
import Dico from '../../helpers/Dico';
import ContMessageI18N from '../../containers/ContMessageI18N';
import TableTitle from './TableTitle';

class TableSteps extends Component {

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	render() {
		return (
			<TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
				<TableTitle title={this.props.title} fieldname={this.props.fieldname} developperView={this.props.developperView} />
				<div className="row shadow rounded p-0 m-1 table-responsive">
					<table className="table table-light table-striped">
						<thead>
							<tr className='table-primary'>
								<th className='text-center'>{this.props.developperView ? 'order' : this.getMessage('generics.steps.order')}</th>
								<th className='text-start'>{this.props.developperView ? 'type' : this.getMessage('generics.steps.type')}</th>
								<th className='text-end'>{this.props.developperView ? 'nbTerms' : this.getMessage('generics.steps.nbTerms')}</th>
								<th className='text-end'>{this.props.developperView ? 'amountExclTax' : this.getMessage('generics.amountExclTax')}</th>
								<th className='text-end'>{this.props.developperView ? 'amountInclTax' : this.getMessage('generics.amountInclTax')}</th>
							</tr>
						</thead>
						<tbody>
							{this.props.steps.map((line, index) => (
								<tr key={index}>
									<td className='text-center'>{line.order}</td>
									<td className='text-start'>{this.props.developperView ? line.type
										: this.getMessage(`generics.steps.type.${line.type}`)}</td>
									<td className='text-end'>{line.nbTerms}</td>
									{line.amount && <td className='text-end'>
										{this.props.developperView
											? line.amount.amountExclTax
											: Dico.getAmountFormatted(line.amount, 'HT', this.props.context.countryCode, this.props.context.languageCode)}
									</td>}
									{line.amount && <td className='text-end'>
										{this.props.developperView
											? line.amount.amountInclTax
											: Dico.getAmountFormatted(line.amount, 'TC', this.props.context.countryCode, this.props.context.languageCode)}
									</td>}
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</TextWithFieldname>
		)
	}
}

export default (TableSteps)
